import { useEffect, useState, useContext, SetStateAction, useMemo } from 'react';

import { useHelpBundle } from '@plasma/ui.application.app';
import { useNavigate } from '@plasma/ui.application.router';
import notification from '@plasma/ui.feedback.notification';
import { getEventValue } from '@plasma/ui.input.radio-group';
import { useResourceBundle, useTranslation } from '@plasma/ui.utils.i18n';

import { PlantLayoutContext } from '../..';
import {
  apiUriCartDataHttp,
  apiUriDesignDrawingsHttp,
  apiUriGuideDataHttp,
  apiUriMasterDataHttp,
} from '../../services/conf/apiConf';
import { fetchAllDataGet_byApiName, fetchAllDataGetFromAppFile_byApiName } from '../../services/gets/getdata';
import {
  sendAllDataPost_byApiNameAndData,
  getFileOfPdfChangeover_Post,
  pollForFile,
} from '../../services/posts/postdata';
import { CartItemDetails, FilterMode, GuidData, MasterProduct } from '../../types/consumableOverviewtype';
import { ConsumableOverviewProps } from './consumable-overview';
import help from './consumable-overview.help';
import translations from './i18n';

function useConsumableOverviewHook(props: ConsumableOverviewProps) {
  useResourceBundle(translations, undefined, '1d82b8cb-e6bf-40d6-883e-3520245a60d7');
  useHelpBundle(help);

  const { t } = useTranslation();
  const plantLayoutFromMemory = useContext(PlantLayoutContext);

  const [isFirstRender, setIsFirstRender] = useState(true);
  const [prod1, setProd1] = useState<string | null>(null);
  const [prod2, setProd2] = useState<string | null>(null);
  const [prod1Dimension, setProd1Dimension] = useState<string | null>(null);
  const [prod2Dimension, setProd2Dimension] = useState<string | null>(null);
  const [prod1code, setprod1code] = useState<string[]>([]);
  const [prod2code, setprod2code] = useState<string[]>([]);
  const [prod1ProdType, setProd1ProdType] = useState<string[]>([]);
  const [prod2ProdType, setProd2ProdType] = useState<string[]>([]);
  const [prod1Desc, setProd1Desc] = useState<string[]>([]);
  const [prod2Desc, setProd2Desc] = useState<string[]>([]);
  const [visible, setVisible] = useState(false);
  const [consumableSet, setConsumableSet] = useState<any[]>([]);
  const [dataFromPlantLayout, setDataFromPlantLayout] = useState<any>([]);
  const [dataForCustomerConsumables, setDataForCustomerConsumables] = useState<any[]>([]);
  const [dataForColumns, setdataForColumns] = useState<any[]>([]);
  const [searchQuery, setSearchQuery] = useState('');

  const [tableColumns, setTableColumns] = useState<string[]>([]);
  const [cardClick, setCardClick] = useState(false);
  const [verifyCard, setVerifyCardStore] = useState();
  const [count, setCount] = useState<number>(1);
  const [cartItems, setCartItems] = useState<CartItemDetails[]>([]);
  const [cartItemsToSend, setcartItemsToSend] = useState<CartItemDetails[]>([]);
  const [dataForGuid, setdataForGuid] = useState<GuidData[]>([]);
  const [guidByProd, setguidByProd] = useState<string>('');
  const [guidByProdArray, setguidByProdArray] = useState<string[]>([]);
  const [iFrameSrc, setIframeSrc] = useState('');
  const [showModal, setshowModal] = useState(false);
  const [showCodeModal, setshowCodeModal] = useState(false);
  const [codeModalTitle, setcodeModalTitle] = useState('');
  const [selectedCustomerConsumableCodeDetails, setSelectedCustomerConsumableCodeDetails] = useState({});
  const [selectedEquipment, setselectedEquipment] = useState<string | undefined>('');
  const [modalTitle, setmodalTitle] = useState('');
  const [countPage, setcountPage] = useState(0);
  const [pageNumber, setpageNumber] = useState(0);
  const [ButtonTitle, setButtonTitle] = useState<string>('');
  const [handleView, sethandleView] = useState(false);
  const [uniqueConsume, setUniqueConsume] = useState();
  const [masterProdDetails, setmasterProdDetails] = useState<MasterProduct[]>([]);
  const [distinctProdType, setdistinctProdType] = useState<string[]>([]);
  const [differentCosumableCodeArray, setdifferentCosumableCodeArray] = useState<any[]>([]);
  const [usedProfilesForCode, setusedProfilesForCode] = useState([]);
  const [usedEquipmentsForCode, setusedEquipmentsForCode] = useState([]);
  const [descriptionForCode, setdescriptionForCode] = useState('');
  const [viewDrawing, setviewDrawing] = useState(false);
  const [showChangeOverModal, setshowChangeOverModal] = useState(false);
  const [iFrameSrcForChangeover, setiFrameSrcForChangeover] = useState('');

  const [allGuidData, setallGuidData] = useState([]);
  const [allGuidDataForEquipment, setallGuidDataForEquipment] = useState([]);
  const [loadingFile, setLoadingFile] = useState(false);

  const [filterMode, setFilterMode] = useState<FilterMode>('hide_unused');
  const [optionsLoading, setOptionsLoading] = useState(false);
  const [waitingForFile, setWaitingForFile] = useState(false);

  const navigate = useNavigate();

  const handleAddToCart = (
    index: number,
    productcode: string,
    producttype: string,
    productdescription: string,
    consumableCd: string,
    consumable: string,
    area: string,
    zone: string,
    drawingNumber: number,
  ) => {
    const lineNumber = index + 1;
    setCartItems((prevCartItems) => {
      const existingItemIndex = prevCartItems?.findIndex((item) => {
        return item.lineseq === lineNumber && item.productcode === productcode && item.itemcode === consumableCd;
      });

      if (existingItemIndex !== -1) {
        // If the item already exists, update its quantity
        const updatedCartItems = [...prevCartItems];
        updatedCartItems[existingItemIndex].itemcount += 1;
        updatedCartItems[existingItemIndex].source = 'CONSUMABLES OVERVIEW';
        updatedCartItems[existingItemIndex].itemtype = 'CONSUMABLES';
        return updatedCartItems;
      }

      // If the item doesn't exist, add a new item to the cart
      const newItem = {
        itemtype: 'CONSUMABLES',
        itemcode: consumableCd,
        itemcount: 1,
        totalItemsCount: 0,
        itemcost: 0,
        currency: '',
        productcode,
        lineseq: lineNumber,
        displayseq: 0,
        productType: producttype.split(':')[1].trim(),
        productDescription: productdescription.trim(),
        equipmentCode: '',
        equipmentName: '',
        consumableName: consumable,
        areaName: area,
        zoneName: zone,
        drawingNumber: '',
        source: 'CONSUMABLES OVERVIEW',
      };
      return [...prevCartItems, newItem];
    });

    setIsFirstRender(false);
  };

  const getCartItemsOfConsumable = (
    index: number,
    productcode: string,
    producttype: string,
    productdescription: string,
    consumableCd: string,
    consumable: string,
    area: string,
    zone: string,
    equipment: string,
  ) => {
    const lineNumber = index + 1;
    // Find the existing item in the cartItems array based on the attributes
    const existingItem = cartItems.filter(
      (item) => item.lineseq === lineNumber && item.productcode === productcode && item.itemcode === consumableCd,
    );

    const totalCount = existingItem.reduce((total, item) => total + item.itemcount, 0);

    // Return the quantity of the existing item if found, otherwise return 0
    return existingItem.length ? totalCount : 0;
  };

  const handleRemoveFromCart = async (
    index: number,
    productcode: string,
    producttype: string,
    productdescription: string,
    consumableCd: string,
    consumable: string,
    area: string,
    zone: string,
    drawingNumber: string,
  ) => {
    const lineNumber = index + 1;
    setCartItems((prevCartItems) => {
      // Check if an item with the same attributes already exists in the cart
      const existingItemIndex = prevCartItems.findIndex((item) => {
        return item.lineseq === lineNumber && item.productcode === productcode && item.itemcode === consumableCd;
      });

      if (existingItemIndex !== -1 && prevCartItems[existingItemIndex].itemcount > 0) {
        // If the item exists and its quantity is more than 0, decrease its quantity
        const updatedCartItems = [...prevCartItems];
        updatedCartItems[existingItemIndex].itemcount -= 1;
        updatedCartItems[existingItemIndex].source = 'CONSUMABLES OVERVIEW';
        return updatedCartItems;
      }
      return prevCartItems;
    });
    setIsFirstRender(false);
  };

  useEffect(() => {
    setcartItemsToSend(cartItems);
  }, [cartItems]);

  useEffect(() => {
    if (!isFirstRender) {
      setLoadingFile(true);
      sendAllDataPost_byApiNameAndData(
        'PostItemInShoppingCartConsumableUtilization',
        cartItemsToSend,
        apiUriCartDataHttp(),
      )
        .then((response) => {
          if (response) {
            //notification.success('Fetched !', 'Item Added to Cart Successfully', undefined, 'medium', 1)
          }
        })
        .catch((error) => {
          //console.log(error);
        })
        .finally(() => {
          setLoadingFile(false);
        });
    }
  }, [cartItemsToSend, isFirstRender]);

  const handleGoHome = () => {
    navigate('/home-screen');
  };

  const handleProd1Change = (value: string) => {
    setOptionsLoading(true);
    setProd1(value);
    setProd1Dimension(null);
    fetchOrSaveSelectedOptions(`${value} ---- ${prod1Dimension}`, `${prod2} ---- ${prod2Dimension}`, false);
  };

  const handleProd1DimChange = (value: string) => {
    setOptionsLoading(true);
    setProd1Dimension(value);
    fetchOrSaveSelectedOptions(`${prod1} ---- ${value}`, `${prod2} ---- ${prod2Dimension}`, false);
  };

  const handleProd2Change = (value: string) => {
    setOptionsLoading(true);
    setProd2(value);
    setProd2Dimension(undefined);
    fetchOrSaveSelectedOptions(`${prod1} ---- ${prod1Dimension}`, `${value} ---- ${prod2Dimension}`, false);
  };

  const handleProd2DimeChange = (value: string) => {
    setOptionsLoading(true);
    setProd2Dimension(value);
    fetchOrSaveSelectedOptions(`${prod1} ---- ${prod1Dimension}`, `${prod2} ---- ${value}`, false);
  };

  const handleFetch = () => {
    setVisible(true);
  };

  useEffect(() => {
    setOptionsLoading(true);
    fetchInitialData();
  }, []);

  const fetchInitialData = async () => {
    await fetchAllDataGet_byApiName('GetMasterProductDetails', apiUriMasterDataHttp())
      .then((data) => {
        setmasterProdDetails(data);
      })
      .catch((error) => {
        console.log('Failed to Fetch MasterProduct Details Data', error);
      });

    await fetchAllDataGetFromAppFile_byApiName('GetDocumentGuids', apiUriDesignDrawingsHttp())
      .then((data) => {
        setdataForGuid(data);
      })
      .catch((error) => {
        console.log('Failed to Fetch Document GUIDs Data', error);
      });

    await fetchAllDataGet_byApiName('getItemInShoppingCartToEdit', apiUriCartDataHttp())
      .then((data) => {
        setCartItems(data);
      })
      .catch((error) => {
        console.log('Failed to Fetch Shopping Cart Data', error);
      });

    setConsumableSet(plantLayoutFromMemory?.layoutData ?? []);
    setDataFromPlantLayout(plantLayoutFromMemory?.layoutData ?? []);

    // await fetchAllDataGet_byApiName("GetMEGConsumables").then((data) => {
    //   setDataForCustomerConsumables(data);
    // }).catch((error)=>{
    //   console.log("Failed to Fetch Data");
    // });

    fetchOrSaveSelectedOptions('', '', true);
    fetchInitialDataForPdf();
  };

  const fetchOrSaveSelectedOptions = async (prod1: string, prod2: string, get: boolean) => {
    const dataForSelections = {
      productCode1: prod1,
      productCode2: prod2,
      get,
    };

    await sendAllDataPost_byApiNameAndData('AddOrGetTempProductCode', dataForSelections, apiUriGuideDataHttp())
      .then((response) => {
        if (response && response.productCode1 && response.productCode2 && typeof get !== 'undefined') {
          const productCode1 = response.productCode1.split(' ---- ') || [];
          const productCode2 = response.productCode2.split(' ---- ') || [];

          if (productCode1.length > 0 && productCode1[0] !== 'undefined' && productCode1[0] !== '') {
            setProd1(productCode1[0]);
          } else {
            setProd1(undefined);
          }

          if (productCode1.length > 1 && productCode1[1] !== 'undefined' && productCode1[1] !== '') {
            setProd1Dimension(productCode1[1]);
          } else {
            setProd1Dimension(undefined);
          }

          if (productCode2.length > 0 && productCode2[0] !== 'undefined' && productCode2[0] !== '') {
            setProd2(productCode2[0]);
          } else {
            setProd2(undefined);
          }

          if (productCode2.length > 1 && productCode2[1] !== 'undefined' && productCode2[1] !== '') {
            setProd2Dimension(productCode2[1]);
          } else {
            setProd2Dimension(undefined);
          }
        }
        setOptionsLoading(false);
      })
      .catch((error) => {
        console.error('Error:', error);
        setOptionsLoading(false);
      });
  };

  useEffect(() => {
    const distinctProductTypes = Array?.from(new Set(masterProdDetails?.map((item) => item.producttype)));
    setdistinctProdType(distinctProductTypes);
    setProd1ProdType(distinctProductTypes);
    setProd2ProdType(distinctProductTypes);
  }, [masterProdDetails]);

  useEffect(() => {
    const descAgainstProd1Type = masterProdDetails
      ?.filter((oneItem) => oneItem.producttype === prod1)
      .map((item) => item.productdescription);
    const finalDimension = descAgainstProd1Type?.filter((item) => item !== prod2Dimension);
    setProd1Desc(finalDimension);
  }, [distinctProdType, prod1, prod2Dimension, masterProdDetails]);

  useEffect(() => {
    const descAgainstProd2Type = masterProdDetails
      ?.filter((oneItem) => oneItem.producttype === prod2)
      .map((item) => item.productdescription);
    const finalDimension = descAgainstProd2Type?.filter((item) => item !== prod1Dimension);
    setProd2Desc(finalDimension);
  }, [distinctProdType, prod2, prod1Dimension, masterProdDetails]);

  useEffect(() => {
    const prodCode = masterProdDetails
      ?.filter((oneItem) => oneItem.producttype === prod1 && oneItem.productdescription === prod1Dimension)
      ?.map((item) => item.productcode);
    setprod1code(prodCode);
  }, [masterProdDetails, prod1, prod1Dimension]);

  useEffect(() => {
    const prodCode = masterProdDetails
      ?.filter((oneItem) => oneItem.producttype === prod2 && oneItem.productdescription === prod2Dimension)
      ?.map((item) => item.productcode);
    setprod2code(prodCode);
  }, [masterProdDetails, prod2, prod2Dimension]);

  useEffect(() => {
    let fieldProd1 = '';
    let fieldProd2 = '';
    if (prod1 && prod1Dimension) {
      fieldProd1 = `${prod1code}: ${prod1}-${prod1Dimension}`;
    }
    if (prod2 && prod2Dimension) {
      fieldProd2 = `${prod2code}: ${prod2}-${prod2Dimension}`;
    }
    const dataTodisplay =
      consumableSet &&
      consumableSet?.map((item_consumableSet) => {
        let prod1Items: MasterProduct | undefined;
        let prod2Items: MasterProduct | undefined;
        item_consumableSet.consumables?.map(
          (item_of_item_consumableset: {
            productprofiles: MasterProduct[];
            consumablecodeext: string;
            consumabledescription: string;
            quantityinstalled: number;
          }) => {
            prod1Items = item_of_item_consumableset.productprofiles?.find(
              (item_prodProf: { producttype: string | undefined; productdescription: string | undefined }) =>
                item_prodProf.producttype === prod1 && item_prodProf.productdescription === prod1Dimension,
            );
            prod2Items = item_of_item_consumableset.productprofiles?.find(
              (item_prodProf: { producttype: string | undefined; productdescription: string | undefined }) =>
                item_prodProf.producttype === prod2 && item_prodProf.productdescription === prod2Dimension,
            );

            const itemRecord = item_consumableSet as Record<string, unknown>;
            if (prod1Items && fieldProd1) {
              itemRecord[fieldProd1] = item_of_item_consumableset.consumablecodeext;
            }
            if (prod2Items && fieldProd2) {
              itemRecord[fieldProd2] = item_of_item_consumableset.consumablecodeext;
            }
            itemRecord.Consumable = item_of_item_consumableset.consumabledescription;
            itemRecord.quantityInstalled = item_of_item_consumableset.quantityinstalled;
          },
        );
        return item_consumableSet;
      });

    setdataForColumns(dataTodisplay);
    setTableColumns([fieldProd1, fieldProd2]);
  }, [consumableSet, prod1, prod2, prod1Desc, prod2Desc]);

  useEffect(() => {
    const profile1 = `${prod1code}: ${prod1}-${prod1Dimension}`;
    const profile2 = `${prod2code}: ${prod2}-${prod2Dimension}`;
    const unmatchedCodeArray: any[] = [];

    dataForColumns?.map((oneData, index) => {
      //console.log(oneData ,'code: ', oneData[profile2]);
      if (oneData[profile1] !== oneData[profile2]) {
        unmatchedCodeArray.push({
          productProfile1: `${prod1}-${prod1Dimension}`,
          productProfile2: `${prod2}-${prod2Dimension}`,
          consumableCode1: oneData[profile1],
          consumableCode2: oneData[profile2],
          rowIndex: index,
          area: oneData.areacode,
          zone: oneData.zonecode,
          consumable: oneData.Consumable,
          equipmentCode: oneData.equipmentcode,
          displaySeq: oneData.displayseq,
          drawingNumber: oneData.drawingnumber,
        });
      }
    });
    setdifferentCosumableCodeArray(unmatchedCodeArray);
  }, [dataForColumns]);

  const fetchInitialDataForPdf = () => {
    fetchAllDataGetFromAppFile_byApiName('GetConsumableItemDocumentGuid', apiUriDesignDrawingsHttp())
      .then((data) => {
        setallGuidData(data);
      })
      .catch((error) => {
        console.log('Failed to Fetch Data');
      });

    fetchAllDataGetFromAppFile_byApiName('GetEquipmentDocumentGuids', apiUriDesignDrawingsHttp())
      .then((data) => {
        setallGuidDataForEquipment(data);
      })
      .catch((error) => {
        console.log('Failed to Fetch Data');
      });
  };

  const handleCardClick = (value: SetStateAction<undefined>) => {
    setCardClick(true);
    //console.log(value);
    setVerifyCardStore(value);
  };

  const handleAdd = () => {};
  const handleRemove = () => {};

  const handleClear = () => {
    setProd1(null);
    setProd2(null);
    setProd1Dimension(null);
    setProd2Dimension(null);
  };

  useEffect(() => {
    if (ButtonTitle !== '' && dataForColumns && dataForGuid.length > 0) {
      const guidByProdType = dataForGuid?.find((item) => item.producttype === ButtonTitle);
      setguidByProdArray(guidByProdType?.guid ?? []);
      setguidByProd(guidByProdType?.guid[0] ?? '');
      setcountPage(0);
    }
  }, [ButtonTitle, dataForGuid]);

  const handleRollPassForProduct = (oneProd: SetStateAction<string> | undefined) => {
    if (oneProd === prod1) {
      setmodalTitle(`Roll Pass for Product 1 : ${prod1}-${prod1Dimension}`);
    } else {
      setmodalTitle(`Roll Pass for Product 2 : ${prod2}-${prod2Dimension}`);
    }
    setButtonTitle(oneProd ?? '');
    setpageNumber(1);
    sethandleView(!handleView);
  };

  useEffect(() => {
    if (guidByProd !== '' && guidByProd !== undefined && guidByProd !== null) {
      handleAfterButtonClick();
    } else {
      setIframeSrc('');
    }
  }, [guidByProd, handleView]);

  const handleNextPage = () => {
    if (guidByProdArray.length > 1 && countPage < guidByProdArray.length - 1) {
      const guidindex = countPage + 1;
      setpageNumber(guidindex + 1);
      setcountPage(countPage + 1);
      setguidByProd(guidByProdArray[guidindex]);
    }
  };

  const handlePreviousPage = () => {
    if (countPage > 0) {
      const guidindex = countPage - 1;
      setpageNumber(guidindex + 1);
      setcountPage(countPage - 1);
      setguidByProd(guidByProdArray[guidindex]);
    }
  };

  const HandleModalCancel = () => {
    setIframeSrc('');
    setshowModal(false);
  };

  const HandleCodeModalCancel = () => {
    setusedProfilesForCode([]);
    setusedEquipmentsForCode([]);
    setshowCodeModal(false);
    setcodeModalTitle('');
  };

  const handleConsumableCodeClick = (rowIndex: number, code: SetStateAction<string>) => {
    const dispSeq = rowIndex + 1;

    if (dataFromPlantLayout && dataFromPlantLayout.length > 0) {
      const profilesForCode = dataFromPlantLayout
        ?.filter((onedataFromPlantLayout: { displayseq: any }) => onedataFromPlantLayout.displayseq === dispSeq)[0]
        .consumables?.filter((oneData: { consumablecodeext: any }) => oneData.consumablecodeext === code)
        ?.map((oneItem: { productprofiles: any }) => oneItem.productprofiles);

      const nameForCode = dataFromPlantLayout
        ?.filter((onedataFromPlantLayout: { displayseq: any }) => onedataFromPlantLayout.displayseq === dispSeq)[0]
        .consumables?.filter((oneData: { consumablecodeext: any }) => oneData.consumablecodeext === code);

      const equipmentsForCode = dataFromPlantLayout
        ?.map((onedataFromPlantLayout: { consumables: any[] }) => {
          const filteredCode = onedataFromPlantLayout.consumables?.filter(
            (oneData: { consumablecodeext: any }) => oneData.consumablecodeext === code,
          );
          if (filteredCode && filteredCode.length > 0) {
            return onedataFromPlantLayout;
          }
        })
        ?.filter((item: null | undefined) => item !== undefined && item !== null);

      const customerConsumableDetails = dataForCustomerConsumables?.find(
        (item: any) => item.smsConsumableCodeExt === code,
      );

      //console.log("Customer Detail: ", customerConsumableDetails);

      setdescriptionForCode(nameForCode[0]?.consumabledescription);
      setusedProfilesForCode(profilesForCode[0]);
      setusedEquipmentsForCode(equipmentsForCode);
      setshowCodeModal(true);
      setcodeModalTitle(code);
      setSelectedCustomerConsumableCodeDetails(customerConsumableDetails);
    }
  };

  const handleDrawingModalCancel = () => {
    setIframeSrc('');
    setviewDrawing(false);
    setselectedEquipment(undefined);
  };

  const handleGoToCart = () => {
    navigate('/shopping-cart/overview');
  };

  const handlePdfOfChangeover = async () => {
    setshowChangeOverModal(true);
    setWaitingForFile(true);

    notification.info('Request Sent', 'Waiting for PDF', t, 'medium', 15);
    getFileOfPdfChangeover_Post('GenerateProductChangeReport', differentCosumableCodeArray, apiUriGuideDataHttp())
      .then((response) => {
        notification.success('File Received', 'PDF Generated');
        setiFrameSrcForChangeover(response);
        setWaitingForFile(false);
      })
      .catch((error) => {
        setWaitingForFile(false);
        notification.info('Request Failed', 'PDF generation failed');
      });
  };

  const handleCancelChangeoverModal = () => {
    setshowChangeOverModal(false);
  };

  const handleEquipmentClick = (data: string) => {
    const guidForSelectedEquipment: any = allGuidDataForEquipment?.find((item: any) => item.docfor === data);

    fetchAndSetIframeSource(guidForSelectedEquipment?.guid[0], 'GetEquipmentDesign', apiUriDesignDrawingsHttp());
    setselectedEquipment(data);
    setviewDrawing(true);
  };

  const handleDrawingModal = () => {
    const guidForSelectedCode: any = allGuidData?.find((item: any) => item.docfor === codeModalTitle);
    fetchAndSetIframeSource(
      guidForSelectedCode ? guidForSelectedCode.guid[0] : undefined,
      'getConsumableItemDesign',
      apiUriDesignDrawingsHttp(),
    );
    setviewDrawing(true);
  };

  const handleAfterButtonClick = () => {
    fetchAndSetIframeSource(guidByProd, 'getRollPassDesign', apiUriDesignDrawingsHttp());
    setshowModal(true);
  };

  async function fetchAndSetIframeSource(guId: string | undefined, apiName: string, baseUri?: string) {
    setLoadingFile(true);
    if (guId === undefined) {
      setIframeSrc('');
      setLoadingFile(false);
    } else {
      try {
        const queryParams = new URLSearchParams({
          guid: guId,
          // Add more query parameters as needed
        });

        const blob = await pollForFile(`${apiName}?${queryParams}`, {}, undefined, undefined, baseUri);
        const blobUrl = URL.createObjectURL(blob);
        setIframeSrc(blobUrl); // Set iframe source only after successful API call
      } catch (error) {
        console.error('Error during API call:', error);
      } finally {
        setLoadingFile(false);
      }
    }
    setLoadingFile(false);
  }

  const handleFilterChange = (e: any) => {
    const val = getEventValue(e) as FilterMode;
    setFilterMode(val);
  };

  // Suggestions for the search box: the distinct areas, zones and consumables of the rows on the screen, grouped and
  // filtered by what has been typed. A name already listed under an earlier group isn't repeated.
  const searchSuggestions = useMemo(() => {
    const query = searchQuery.toLowerCase().trim();
    const seen = new Set<string>();
    const MaxPerGroup = 20;

    const group = (label: string, values: (string | undefined)[]) => {
      const options: { value: string; label: string }[] = [];
      Array.from(new Set(values.map((v) => v?.trim()).filter((v): v is string => !!v)))
        .sort((a, b) => a.localeCompare(b))
        .forEach((value) => {
          if (options.length >= MaxPerGroup || seen.has(value.toLowerCase())) return;
          if (query && !value.toLowerCase().includes(query)) return;
          seen.add(value.toLowerCase());
          options.push({ value, label: value });
        });
      return { label, options };
    };

    const column = (key: string) =>
      dataForColumns.map((row) => (row?.[key] === null || row?.[key] === undefined ? undefined : String(row[key])));

    return [
      group('Area', column('areacode')),
      group('Zone', column('zonecode')),
      group('Consumable', column('Consumable')),
    ].filter((g) => g.options.length > 0);
  }, [dataForColumns, searchQuery]);

  return {
    t,
    handleFilterChange,
    handleGoHome,
    prod1,
    prod2,
    handleProd1Change,
    prod1Dimension,
    handleProd1DimChange,
    handleProd2DimeChange,
    handleProd2Change,
    prod2Dimension,
    prod1ProdType,
    prod2ProdType,
    prod1Desc,
    prod2Desc,
    handleFetch,
    visible,
    tableColumns,
    dataForColumns,
    handleCardClick,
    cardClick,
    handleAdd,
    handleRemove,
    verifyCard,
    count,
    handleAddToCart,
    handleRemoveFromCart,
    cartItems,
    showModal,
    showCodeModal,
    modalTitle,
    iFrameSrc,
    guidByProd,
    guidByProdArray,
    pageNumber,
    loadingFile,
    setCartItems,
    handleClear,
    handleGoToCart,
    handleRollPassForProduct,
    HandleModalCancel,
    HandleCodeModalCancel,
    getCartItemsOfConsumable,
    handleNextPage,
    handlePreviousPage,
    uniqueConsume,
    handleConsumableCodeClick,
    handlePdfOfChangeover,
    handleDrawingModal,
    handleDrawingModalCancel,
    handleCancelChangeoverModal,
    handleEquipmentClick,
    viewDrawing,
    differentCosumableCodeArray,
    codeModalTitle,
    usedProfilesForCode,
    usedEquipmentsForCode,
    descriptionForCode,
    showChangeOverModal,
    iFrameSrcForChangeover,
    selectedEquipment,
    optionsLoading,
    waitingForFile,
    allGuidData,
    selectedCustomerConsumableCodeDetails,
    allGuidDataForEquipment,
    filterMode,
    setFilterMode,
    searchQuery,
    setSearchQuery,
    searchSuggestions,
  };
}

export default useConsumableOverviewHook;
